import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bibShape } from '@bibliocommons/bc-prop-types';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import BibLink from 'app/components/shared/BibLink';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { seriesCardEventComposer } from '@bibliocommons/analytics-event-composers';

import './BibCard.scss';

const { composeImageClickEvent, composeTitleClickEvent } = seriesCardEventComposer;

function handleClickEvent(compose, bib) {
  const providerURI = bib.getIn(['coverImage', 'providerURI']);
  const metadataId = bib.get('metadataId');
  sendAnalyticsEvents(
    compose({
      providerURI,
      metadataId
    })
  );
}

export default function BibCard({ bib, number, isCurrentItem }) {
  function renderJacketCover() {
    return <JacketCover src={bib.get('coverImage')} format={bib.get('format')} />;
  }

  function renderTitle() {
    return <div className="bib-title">{bib.get('title')}</div>;
  }

  return (
    <div className="cp-bib-card">
      <div className="bib-card-contents">
        {
          <div className="number">
            {number && !bib.get('volumeLabel') && (
              <>
                <span aria-hidden="true">{number}</span>
                <ScreenReaderMessage>
                  <FormattedMessage id="seriesTitleNumber" values={{ number }} />
                </ScreenReaderMessage>
              </>
            )}
          </div>
        }
        <div className="bib-wrapper">
          <BibLink
            metadataId={bib.get('metadataId')}
            handleClick={() => handleClickEvent(composeImageClickEvent, bib)}
            isDecorative
          >
            {renderJacketCover()}
          </BibLink>
          <BibLink
            className="title-link"
            metadataId={bib.get('metadataId')}
            handleClick={() => handleClickEvent(composeTitleClickEvent, bib)}
          >
            {renderTitle()}
          </BibLink>
          {isCurrentItem && (
            <div className="current-item-indicator">
              <FormattedMessage id="this_item" />
            </div>
          )}
          {bib.get('volumeLabel') && <>({bib.get('volumeLabel')})</>}
        </div>
      </div>
    </div>
  );
}

BibCard.propTypes = {
  bib: bibShape,
  number: PropTypes.number,
  isCurrentItem: PropTypes.bool
};
